import { render } from "./ProjectElementsStep.vue?vue&type=template&id=5f05af6b"
import script from "./ProjectElementsStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectElementsStep.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Admin/Project/ProjectElementsStep.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f05af6b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f05af6b', __exports__)) {
    api.reload('5f05af6b', __exports__)
  }
  
  module.hot.accept("./ProjectElementsStep.vue?vue&type=template&id=5f05af6b", () => {
    api.rerender('5f05af6b', render)
  })

}


export default __exports__